import React from 'react';
import { motion } from 'framer-motion';
const spaces = [{
  name: 'The Grand Hall',
  description: 'An architectural masterpiece featuring vaulted ceilings and crystal chandeliers, perfect for lavish indoor receptions.',
  image: 'https://images.unsplash.com/photo-1544078751-58fee2d8a03b?w=1000&q=80'
}, {
  name: 'The Terrace',
  description: 'Overlooking the valley, this expansive stone terrace offers a breathtaking backdrop for sunset ceremonies.',
  image: 'https://images.unsplash.com/photo-1469371670807-013ccf25f16a?w=800&q=80'
}, {
  name: 'The Garden Pavilion',
  description: 'Surrounded by blooming flora, an intimate glass-enclosed space ideal for rehearsal dinners and smaller gatherings.',
  image: 'https://images.unsplash.com/photo-1530103862676-de8c9debad1d?w=800&q=80'
}];
export function Spaces() {
  return <section id="spaces" className="bg-white py-24 md:py-32 px-6" data-id="element-243">
      <div className="max-w-[1400px] mx-auto" data-id="element-244">
        <div className="mb-16 md:mb-20 max-w-2xl" data-id="element-245">
          <span className="block text-copper text-xs font-semibold tracking-[0.2em] uppercase mb-4" data-id="element-246">
            Our Spaces
          </span>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-charcoal leading-tight" data-id="element-247">
            Curated Settings for Every Chapter
          </h2>
          <div className="mt-8 w-24 h-[1px] bg-copper/40" data-id="element-248" />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 lg:gap-5 auto-rows-auto" data-id="element-249">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="lg:col-span-7 lg:row-span-2 group relative overflow-hidden cursor-pointer" data-id="element-250">
            <div className="aspect-[4/5] md:aspect-[4/3] lg:aspect-auto lg:h-full lg:min-h-[620px]" data-id="element-251">
              <img src={spaces[0].image} alt={spaces[0].name} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" data-id="element-252" />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" data-id="element-253" />
            <div className="absolute bottom-0 left-0 p-8 md:p-12" data-id="element-254">
              <h3 className="font-serif text-3xl md:text-4xl text-white mb-3" data-id="element-255">
                {spaces[0].name}
              </h3>
              <p className="text-white/80 font-light text-sm leading-relaxed max-w-md opacity-0 group-hover:opacity-100 translate-y-4 group-hover:translate-y-0 transition-all duration-500" data-id="element-256">
                {spaces[0].description}
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.15
        }} className="lg:col-span-5 group relative overflow-hidden cursor-pointer" data-id="element-257">
            <div className="aspect-[4/3] lg:aspect-auto lg:h-[300px]" data-id="element-258">
              <img src={spaces[1].image} alt={spaces[1].name} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" data-id="element-259" />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" data-id="element-260" />
            <div className="absolute bottom-0 left-0 p-6 md:p-8" data-id="element-261">
              <h3 className="font-serif text-2xl md:text-3xl text-white mb-2" data-id="element-262">
                {spaces[1].name}
              </h3>
              <p className="text-white/80 font-light text-sm leading-relaxed opacity-0 group-hover:opacity-100 translate-y-4 group-hover:translate-y-0 transition-all duration-500" data-id="element-263">
                {spaces[1].description}
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="lg:col-span-5 group relative overflow-hidden cursor-pointer" data-id="element-264">
            <div className="aspect-[4/3] lg:aspect-auto lg:h-[300px]" data-id="element-265">
              <img src={spaces[2].image} alt={spaces[2].name} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" data-id="element-266" />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" data-id="element-267" />
            <div className="absolute bottom-0 left-0 p-6 md:p-8" data-id="element-268">
              <h3 className="font-serif text-2xl md:text-3xl text-white mb-2" data-id="element-269">
                {spaces[2].name}
              </h3>
              <p className="text-white/80 font-light text-sm leading-relaxed opacity-0 group-hover:opacity-100 translate-y-4 group-hover:translate-y-0 transition-all duration-500" data-id="element-270">
                {spaces[2].description}
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}